'use client';

import { useSuspenseQuery } from '@tanstack/react-query';

import { UnauthQueryOptions } from '@/api';

export const useAffiliateMerchants = () =>
  useSuspenseQuery({
    ...UnauthQueryOptions['get:/wello/v1/allows/affiliate/merchants'](),
    select: (response) => response.context?.contents ?? [],
  });

export type AffiliateMerchant = ReturnType<
  typeof useAffiliateMerchants
>['data'][number];
